export default __webpack_public_path__ + "static/media/07_Business_Development_Innovation_Guidelines.678d3021.pdf";